export default {"src":"/_next/static/media/Library.4f6c7e9d.svg","height":16,"width":16};